import { render, staticRenderFns } from "./SearchBar.component.vue?vue&type=template&id=09f88974&scoped=true&"
import script from "./SearchBar.component.vue?vue&type=script&lang=ts&"
export * from "./SearchBar.component.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBar.component.vue?vue&type=style&index=0&id=09f88974&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f88974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
